import TargetBodyModal from './TargetBodyModal';

export default TargetBodyModal;
